import { EndpointCallParams } from '@core/api/endpointCallParams';

import { IApiStore } from '@core/api/apiStore';

export type GetGradingsParam = {
  executionIds?: string[],
  actorIds?: string[],
  ActorIds?: string[],
  IsReviewed?: boolean,
  minScore?: number,
  maxScore?: number,
  minReviewedScore?: number,
  maxReviewedScore?: number,
  From?: string | Date,
  To?: string | Date,
  from?: Date,
  to?: Date,
};

export const performGetGradings = async (api: IApiStore, params: EndpointCallParams<GetGradingsParam>) => {
    const { payload, ...rest } = params;
    const req = api
        .post('neoanalytics-app/api/v1/gradings/query', {
            ...rest,
            payload: { ...payload },
        })

    return req;
}
